export const SECTION = {
  home: 'home',
  about: 'about',
  services: 'services',
  references: 'references',
  contact: 'contact'
} as const

export const SECTION_HREF = {
  home: `#${SECTION.home}`,
  about: `#${SECTION.about}`,
  services: `#${SECTION.services}`,
  references: `#${SECTION.references}`,
  contact: `#${SECTION.contact}`
} as const

export const NAV_SECTION_HREFS = [
  SECTION_HREF.home,
  SECTION_HREF.about,
  SECTION_HREF.services,
  SECTION_HREF.references,
  SECTION_HREF.contact
] as const

export type NavSectionHref = (typeof NAV_SECTION_HREFS)[number]